
            const data = {"name":"feather/calendar","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<rect pid=\"0\" x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" ry=\"2\"/><path pid=\"1\" d=\"M16 2v4M8 2v4M3 10h18\"/>","originalColors":[],"stopColors":[]}}
        
                module.exports = data
                